// extracted by mini-css-extract-plugin
export default {"wrapper":"table_wrapper__GbbzI"};